export default __webpack_public_path__ + "static/media/billablehours_hero.31231ee1.png";